export default function drawer({ variables }) {
    return {
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    backgroundColor: variables.surface,
                    borderRight: `1px solid ${variables.border_subtle}`,
                    borderRadius: 0,
                    backgroundImage: "none",
                },
            },
        },
    };
}
//# sourceMappingURL=drawer.js.map